<template>
  <div class="container">
    <div class="integral new-input-box">
      <div class="decor-content" v-if="!isHasSave">
        <div class="newsInfo" style="margin-top: 20px">中奖名单列表装修</div>
        <div class="content-form">
          <el-form :model="formSave" label-width="124px" required>
            <el-form-item label="页面标题：">
              <el-input
                v-model="formSave.title"
                placeholder="请输入"
                style="width: 320px"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="中奖文案：">
              <el-input
                v-model="formSave.winText"
                placeholder="查到以下中奖记录"
                style="width: 320px"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="未中奖文案">
              <el-input
                v-model="formSave.losingText"
                placeholder="很遗憾，你未中奖"
                style="width: 320px"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="活动背景图：">
              <div class="flex-style">
                <el-upload
                  style="display: flex; align-items: center"
                  action="/jd-hd-web/image/upload"
                  ref="upload"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccess"
                  :show-file-list="false"
                  accept=".png, .jpg"
                >
                  <el-button class="btn-blue">自定义上传</el-button>
                </el-upload>
                <el-button
                  style="margin: 0 16px"
                  class="btn-text"
                  @click="
                    formSave.backgroundImage =
                      'https://cdn-image.yucrm.cn//hd/images/13315956_17237a2adda04e1fbcbd60525e74275f.png'
                  "
                  >重置</el-button
                >
                <span class="size-style">
                  尺寸建议：750*1740px；支持格式：jpg，png
                </span>
              </div>
            </el-form-item>
            <el-form-item label="标题文字颜色">
              <div class="color-item">
                <el-color-picker
                  v-model="formSave.titleColor"
                ></el-color-picker>
                <el-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="formSave.titleColor = '#B46E1D'"
                  class="btn-text"
                  >重置</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="按钮设置：">
              <div class="btn-setting">
                <div class="color-item">
                  按钮背景色：
                  <el-color-picker
                    v-model="formSave.buttonBgColor"
                  ></el-color-picker>
                  <el-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="formSave.buttonBgColor = '#D19D71'"
                    class="btn-text"
                    >重置</el-button
                  >
                </div>
                <div class="color-item" style="margin-top: 20px">
                  按钮文字色：
                  <el-color-picker
                    v-model="formSave.buttonTextColor"
                  ></el-color-picker>
                  <el-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="formSave.buttonTextColor = '#ffffff'"
                    class="btn-text"
                    >重置</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序店铺信息：" label-width="150px">
              <el-radio-group v-model="formSave.shopNameType">
                  <el-radio :label="0">统一显示配置店铺</el-radio>
                  <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div class="footer">
            <el-button @click="savePointSetting" class="btn-blue"
              >保存设置</el-button
            >
            <el-button style="margin: 0 12px 0 12px" @click="handleReset"
              >重置</el-button
            >
            <el-button @click="toGiftList" style="width: 122px"
              >去添加中奖名单</el-button
            >
          </div>
        </div>
      </div>
      <div class="extension-content" v-else>
        <div class="newsInfo" style="margin-top: 20px">中奖名单列表推广</div>
        <div class="qrcode-style flexc-cen-x">
          <qrcode-vue
            v-if="qrcodeVue.value"
            :id="'qrcode'"
            :ref="'qrcode'"
            :size="qrcodeVue.size"
            :value="qrcodeVue.value"
            :bgColor="qrcodeVue.bgColor"
            :fgColor="qrcodeVue.fgColor"
            style="text-align: center"
          >
          </qrcode-vue>
          <div class="success-box">
            <div>
              <img
                src="https://cdn-image.yucrm.cn/1f66a21766464bbe91baacc6826e52e3.png"
                alt=""
              />
            </div>
            <div class="flex-1">
              <div class="success-title">页面设置完成~</div>
              <div
                style="
                  margin-top: 12px;
                  font-size: 14px;
                  color: #666666;
                  line-height: 20px;
                "
              >
                您还可以通过以下方式完成推广
              </div>
              <div style="font-size: 14px; color: #333333; margin-top: 12px">
                <span>更多小程序挂载能力</span>
                <el-button class="btn-text" @click="goPages"
                  >点击查看>></el-button
                >
              </div>
              <el-button style="margin-top: 30px" @click="handleSrcImg"
                >下载二维码</el-button
              >
            </div>
          </div>
        </div>
        <div class="code-tips">京东APP扫码查看</div>
        <div class="copy-link">
          <el-tooltip
            class="item"
            effect="dark"
            :content="qrcodeVue.value"
            placement="top-start"
          >
            <div class="line-text">推广链接：{{ qrcodeVue.value }}</div>
          </el-tooltip>
          <span
            style="color: #7b61ff; margin-left: 12px; cursor: pointer"
            v-clipboard:copy="qrcodeVue.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            >复制</span
          >
          <!-- <span
            style="color: #7b61ff; margin-left: 12px; cursor: pointer"
            @click="queryTemplate"
            >更新</span
          > -->
        </div>
        <div class="footer-btn">
          <el-button @click="isHasSave = false" class="btn-blue"
            >装修中奖名单列表</el-button
          >
          <el-button style="margin-left: 12px; width: 122px" @click="toGiftList"
            >去添加中奖名单</el-button
          >
        </div>
      </div>
    </div>
    <div class="decoration-right">
      <div class="newsInfo" style="margin-top: 20px">页面效果预览</div>
      <div style="margin-top: 20px">
        <phoneShow :formConfig="formSave" :list="winList"></phoneShow>
      </div>
    </div>
  </div>
</template>
<script>
import qrcodeVue from "qrcode-vue";
import phoneShow from "./phoneShow.vue";
import { mapState } from "vuex";
import {
  winnerListPage,
  saveDecoration,
  getDecorationInfoDetail,
} from "@/api/winList.js";
export default {
  name: "",
  components: {
    qrcodeVue,
    phoneShow,
  },
  props: {},
  data() {
    return {
      adPicList: [],
      // 限制图片上传格式
      extensions: [".jpg", ".png"],
      isHasSave: false,
      formSave: {
        backgroundImage:
          "https://cdn-image.yucrm.cn//hd/images/13315956_17237a2adda04e1fbcbd60525e74275f.png",
        titleColor: "#B46E1D",
        title: "中奖名单查询",
        winText: "查到以下中奖记录",
        losingText: "很遗憾，你未中奖",
        buttonBgColor: "#D19D71",
        buttonTextColor: "#FFFFFF",
        shopNameType: 0,
      },
      cacheForm: {
        backgroundImage:
          "https://cdn-image.yucrm.cn//hd/images/13315956_17237a2adda04e1fbcbd60525e74275f.png",
        titleColor: "#B46E1D",
        title: "中奖名单查询",
        winText: "查到以下中奖记录",
        losingText: "很遗憾，你未中奖",
        buttonBgColor: "#D19D71",
        buttonTextColor: "#FFFFFF",
        shopNameType: 0,
      },
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      winList: [],
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
  },
  watch: {
    loginUserInfo: {
      handler: function (val) {
        if (val.venderId) {
          this.queryTemplate();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    goPages() {
      this.$router.push("/integralCenter/promotionMode/other_promotion");
    },
    handleReset() {
      this.formSave = JSON.parse(JSON.stringify(this.cacheForm));
      this.adPicList = [];
    },
    deleteHasSelect(index) {
      this.adPicList.splice(index, 1);
      this.formSave.adPic = "";
    },
    toGiftList() {
      // this.$emit("returnStep");
      this.$router.push("/integralCenter/winReport/winReportList");
    },
    queryTemplate() {
      getDecorationInfoDetail(4).then((res) => {
        if (res.code == 1) {
          if (res.data && res.data.id) {
            this.templateId = res.data.id;
            this.formSave = JSON.parse(res.data.detailInfo);
            this.$set(this.formSave,"shopNameType", this.formSave.shopNameType || 0);
            this.adPicList = this.formSave.adPic ? [this.formSave.adPic] : [];
            this.isHasSave = true;
            let xcxUrl = this.$commonUrl(); // 正式
            let params1 = `venderId%3D${res.data.venderId}`;
            this.qrcodeVue.value =
              xcxUrl + "pages_2/winList/winList.html%3f" + params1;
          } else {
            this.qrcodeVue.value = "";
            this.templateId = "";
            this.formSave = JSON.parse(JSON.stringify(this.cacheForm));
            this.isHasSave = false;
          }
        }
        let params = {
          current: 1,
          size: 100,
          venderId: this.loginUserInfo.venderId,
        };
        winnerListPage(params).then((res) => {
          if (res.code == 1) {
            this.winList = res.data.records
              .filter((v) => v.isShow == 1 && v.memberCount > 0)
              .map((v) => ({
                ...v,
                displayFields: v.tableField ? v.tableField.split(",") : [],
              }));
          }
        });
      });
    },
    savePointSetting() {
      if (
        !this.formSave.backgroundImage ||
        !this.formSave.buttonBgColor ||
        !this.formSave.buttonTextColor
      ) {
        this.$message.warning("请先完善页面信息~");
        return;
      }
      let formData = {
        detailInfo: JSON.stringify(this.formSave),
        name: "中奖名单",
        type: 4,
      };
      saveDecoration(formData)
        .then((res) => {
          if (res.code == 1) {
            this.isHasSave = true;
            this.queryTemplate();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(res.message);
        });
    },
    handleColor(val) {
      this.formSave.titleColor = "#B46E1D";
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    handleSuccessMoreActivityImg(res) {
      console.log(res);
      if (res.code == 1) {
        this.$set(this.formSave, "moreActivityImg", res.data);
      } else {
        this.$message.error(res.message);
      }
    },
    handleSuccess(res, file) {
      if (res && res.code == 1) {
        this.$message.success("上传图片成功");
        this.formSave.backgroundImage = res.data;
      }
    },
    handleSuccess1(res, file) {
      if (res && res.code == 1) {
        this.$message.success("上传图片成功");
        this.formSave.adPic = res.data;
        this.adPicList = [this.formSave.adPic];
      }
    },
    beforeUpload(file) {
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs.upload.clearFiles();
        return;
      }
    },
    beforeUpload1(file) {
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs.upload1.clearFiles();
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-blue {
  width: auto;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #7b61ff;
  color: #7b61ff;
  transition: all 0.2s;

  &:hover {
    background-color: #7b61ff;
    color: #fff;
  }
}
.btn-text {
  width: auto;
  padding: 0 !important;
  // margin: 0 !important;
  border: 0 !important;
  color: #7b61ff;
  &:hover {
    background-color: transparent;
  }
}
.btn-break {
  width: auto;
  background-color: #7b61ff;
  color: white;
  border: 1px solid #7b61ff;
}
.success-box {
  margin-left: 30px;
  display: flex;
  img {
    width: 24px;
    height: 24px;
  }
  .success-title {
    line-height: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #1f1f1f;
  }
}
.code-tips {
  width: 200px;
  margin-top: 8px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.line-text {
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.container {
  display: flex;
  flex-wrap: nowrap;
  font-family: PingFang SC, PingFang SC;
  .integral {
    // min-width: 730px;
    flex: 1;
    // width: calc(100% - 432px);
    height: calc(100vh - 118px);
    background: #fff;
    margin-right: 16px;
    padding: 0 16px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow-y: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    .decor-content {
      margin-top: 20px;
      .content-form {
        margin-top: 26px;
        .btn-setting {
          width: 320px;
          background: #f8f9fc;
          padding: 22px 16px;
        }
        .ad-setting {
          width: 500px;
          background: #f8f9fc;
          padding: 16px;
          .common-flex {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            .img-style {
              position: relative;
              width: 100px;
              height: 100px;
              margin-top: 16px;
              margin-right: 20px;
              border-radius: 4px;
              .url-style {
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }
              .close-style {
                cursor: pointer;
                width: 24px;
                height: 24px;
                position: absolute;
                top: 0;
                right: 0;
              }
            }
            .img-style:not(:first-child) {
              margin-left: 20px;
            }
          }
        }
        .color-item {
          display: flex;
          align-items: center;
          color: #666666;
          font-size: 14px;
        }
        .size-style {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          white-space: nowrap;
        }
        .flex-style {
          display: flex;
        }
      }
    }
    .extension-content {
      margin-top: 20px;
      .tips {
        margin: 20px 0;
      }
      .qrcode-style {
        margin-top: 20px;
        // width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        flex-direction: row;
      }
      .copy-link {
        margin-top: 30px;
        display: flex;
        align-items: center;
      }
      .footer-btn {
        margin-top: 50px;
      }
    }
  }
  .decoration-right {
    // width: 416px;
    // background: #ffffff;
    border-radius: 16px;
    height: calc(100vh - 118px);
    // padding: 20px;
    overflow-y: auto;
    .moreActivityImg {
      width: 70px;
      height: 80px;
      position: absolute;
      right: 40px;
      bottom: calc(100vh - 800px);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less" scoped>
// flex
.flex-cen-xy {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexc-cen-x {
  display: flex;
  align-items: center;
}

.flexc-cen-y {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-y {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex-x {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-x-start {
  display: flex;
  align-items: start;
}

.flex-dispaly-wrap {
  display: flex;
  flex-wrap: wrap;
}

.flex-left {
  float: left;
}

.flex-right {
  float: right;
}

.white-spacr-no {
  white-space: nowrap;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.flex-father-box {
  display: flex;
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}
</style>
